// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var BasicEnrollmentGender;
(function (BasicEnrollmentGender) {
    BasicEnrollmentGender["female"] = "female";
    BasicEnrollmentGender["male"] = "male";
    BasicEnrollmentGender["unknown"] = "unknown";
    BasicEnrollmentGender["indeterminate"] = "indeterminate";
    BasicEnrollmentGender["transgender"] = "transgender";
    BasicEnrollmentGender["prefernottoanswer"] = "prefernottoanswer";
})(BasicEnrollmentGender || (BasicEnrollmentGender = {}));
//# sourceMappingURL=basicEnrollmentGender.js.map